(function(){
  "use strict";
  var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  function $(id){ return document.getElementById(id); }
  function all(sel, root){ return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ---- mobile menu ---- */
  var mb = $("menu-btn"), mnav = $("mnav");
  function setMenu(open){ if (!mb) return; mb.setAttribute("aria-expanded", open ? "true" : "false"); mnav.classList.toggle("open", open); }
  if (mb){
    mb.addEventListener("click", function(){ setMenu(mb.getAttribute("aria-expanded") !== "true"); });
    all("#mnav a").forEach(function(a){ a.addEventListener("click", function(){ setMenu(false); }); });
    document.addEventListener("keydown", function(e){ if (e.key === "Escape" && mnav.classList.contains("open")){ setMenu(false); mb.focus(); } });
  }

  /* ---- accordions ---- */
  all(".acc-btn").forEach(function(b){
    b.addEventListener("click", function(){
      var open = b.getAttribute("aria-expanded") === "true";
      b.setAttribute("aria-expanded", open ? "false" : "true");
      var p = $(b.getAttribute("aria-controls")); if (p) p.classList.toggle("open", !open);
    });
  });

  /* ---- announcement rotator ---- */
  var ann = $("ann");
  if (ann && !reduce){
    var annP = ann.querySelectorAll("p");
    if (annP.length > 1) setInterval(function(){
      var alt = ann.classList.toggle("alt");
      annP[0].setAttribute("aria-hidden", alt ? "true" : "false");
      annP[1].setAttribute("aria-hidden", alt ? "false" : "true");
    }, 4000);
  }

  /* ---- cart pill + after-add: the store's cart drawer (sp-cart.js, window.SPCart) when present ----
     sp-cart.js opens its drawer on every successful /cart/add and repaints [data-spc-count]; the pill carries
     data-spc-open so its click handler opens the drawer. Without SPCart: theme <cart-drawer> if any, else /cart. */
  var cartA = $("hdr-cart"), cartN = $("hdr-count");
  function hasSPCart(){ return !!(window.SPCart && document.getElementById("sp-cart-drawer")); }
  function setCount(n){
    if (!cartN) return;
    cartN.textContent = n; cartN.hidden = !(n > 0);
    cartA.setAttribute("aria-label", "Cart, " + n + (n === 1 ? " item" : " items"));
  }
  function refreshCount(){
    if (hasSPCart() || !window.fetch || !cartA) return;
    fetch("/cart.js", { credentials:"same-origin" })
      .then(function(r){ return r.json(); }).then(function(c){ setCount(c.item_count || 0); }).catch(function(){});
  }
  if (cartA){
    cartA.addEventListener("click", function(e){
      if (hasSPCart()) return; /* sp-cart.js handles [data-spc-open] */
      var d = document.querySelector("cart-drawer");
      if (d && typeof d.open === "function"){ e.preventDefault(); d.open(cartA); }
    });
  }
  if (typeof window.subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined"){
    window.subscribe(PUB_SUB_EVENTS.cartUpdate, function(ev){
      refreshCount();
      if (ev && ev.source === "product-form" && !hasSPCart() && !document.querySelector("cart-drawer")){
        window.location.href = (window.routes && routes.cart_url) || "/cart";
      }
    });
  }

  /* ---- PDP gallery thumbs ---- */
  var stageImg = $("pgal-img");
  all(".pthumb").forEach(function(t){
    t.addEventListener("click", function(){
      all(".pthumb").forEach(function(o){ o.setAttribute("aria-current", o === t ? "true" : "false"); });
      if (!stageImg) return;
      stageImg.removeAttribute("srcset");
      stageImg.src = t.getAttribute("data-src");
      if (t.getAttribute("data-srcset")) stageImg.setAttribute("srcset", t.getAttribute("data-srcset"));
      stageImg.alt = t.getAttribute("data-alt") || stageImg.alt;
    });
  });

  /* ---- PDP plan picker: membership (default) or one bag once ---- */
  var plans = document.querySelector(".plans"), planIn = $("sp-plan-input"), btnL = $("pbtn-label");
  var sbarP = $("sbar-price"), sbarPl = $("sbar-plan"), sbarC = $("sbar-cta"), sbarR = $("sbar-renew");
  var form = $("sp-pdp-form");
  /* the PDP form's action is /cart (keeps Seal's auto-widget out); without the theme's <product-form>, post natively to /cart/add */
  if (form) form.addEventListener("submit", function(){
    if (!(window.customElements && customElements.get("product-form"))) form.action = form.getAttribute("data-add-url");
  }, true);
  function setPlan(mode){
    if (!plans || !form) return;
    var once = mode === "once";
    plans.classList.toggle("is-once", once);
    if (planIn) planIn.disabled = once;
    all("[data-show]").forEach(function(el){ el.hidden = el.getAttribute("data-show") !== (once ? "once" : "sub"); });
    var d = ($("pbtn") || form).dataset;
    if (btnL) btnL.textContent = once ? d.onceLabel : d.subLabel;
    if (sbarP) sbarP.innerHTML = once ? d.onceSbar : d.subSbar;
    if (sbarPl) sbarPl.textContent = once ? d.oncePlan : d.subPlan;
    if (sbarC) sbarC.textContent = once ? d.onceCta : d.subCta;
    if (sbarR) sbarR.textContent = once ? d.onceRenew : d.subRenew;
  }
  all('input[name="sp-plan"]').forEach(function(r){ r.addEventListener("change", function(){ if (r.checked) setPlan(r.value); }); });
  var checked = document.querySelector('input[name="sp-plan"]:checked'); if (checked) setPlan(checked.value);

  /* ---- scroll pass: header, sticky bar, reveals ---- */
  var hdr = $("hdr"), sbar = $("sbar"), buy = $("buy"), ftr = document.querySelector(".ftr");
  var top = document.querySelector(".pdp, .phero, .coll");
  var ctas = all("a.btn, .tlink, .pform .btn").filter(function(a){ return !(sbar && sbar.contains(a)) && !(mnav && mnav.contains(a)); });
  function padForBar(){ if (!sbar){ document.body.style.setProperty("--sbar-h", "-14px"); return; } var h = sbar.offsetHeight; if (h) document.body.style.setProperty("--sbar-h", h + "px"); }
  padForBar(); window.addEventListener("resize", padForBar);
  var items = all(".rv");
  if (reduce){ items.forEach(function(el){ el.classList.add("is-in"); }); items = []; }
  var ticking = false;
  function pass(){
    ticking = false;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var y = window.pageYOffset || document.documentElement.scrollTop;
    if (hdr) hdr.classList.toggle("is-scrolled", y > 80);
    if (sbar){
      var inBuy = false;
      if (buy){ var br = buy.getBoundingClientRect(); inBuy = br.bottom > vh * 0.35; }
      var zone = vh - (sbar.offsetHeight || 110) - 8, covers = false;
      for (var c = 0; c < ctas.length && !covers; c++){
        var cr = ctas[c].getBoundingClientRect();
        if (cr.height && cr.bottom > zone && cr.top < vh) covers = true;
      }
      var ftrIn = ftr && ftr.getBoundingClientRect().top < vh;
      sbar.classList.toggle("show", !inBuy && !covers && !ftrIn && !(mnav && mnav.classList.contains("open")));
    }
    for (var i = items.length - 1; i >= 0; i--){
      var r = items[i].getBoundingClientRect();
      if (r.top < vh * 0.92){ items[i].classList.add("is-in"); items.splice(i, 1); }
    }
  }
  function onScroll(){ if (!ticking){ ticking = true; window.requestAnimationFrame(pass); } }
  window.addEventListener("scroll", onScroll, { passive:true });
  window.addEventListener("resize", onScroll);
  window.addEventListener("load", onScroll);
  pass();
})();
